import * as API from "../api.js";

const DEBUG = false;

/**
 * Attention! This function will update variables object!
 */
export default function UploadBase64({ id_project, variables }) {
    const base64FileList = [];

    // Search base64
    (function recursion(_variables) {
        // Object
        if (_variables?.constructor?.name === "Object") {
            DEBUG && console.log("OBJECT");
            DEBUG && console.warn("_variables?.file", _variables?.file);

            // Base64 is object { name, type, dataUrlBase64 }
            if (_variables?.file?.dataUrlBase64) {
                // Yes it is - push
                base64FileList.push({
                    parent: _variables,
                    file: _variables?.file,
                    sizes: _variables?.sizes,
                });
            } else {
                // Goto recursion
                for (const key in _variables) {
                    recursion(_variables[key]);
                }
            }

            return;
        }

        // Otherwise goto recursion

        // Array
        if (Array.isArray(_variables)) {
            DEBUG && console.log("ARRAY", _variables.length, _variables);
            for (const value of _variables) {
                recursion(value);
            }

            return;
        }

        // Unknown
        DEBUG && console.log("UNKNOWN", _variables);
    })(variables);

    // Upload all found
    return Promise.all(
        base64FileList.map(({ parent, file, sizes }) => {
            return fetch(file.dataUrlBase64)
                .then(r => r.blob())
                .then(blob => {
                    const fd = new FormData();
                    fd.set("id_project", id_project);
                    fd.set("file", new File([blob], file.name, { type: file.type }));

                    sizes && fd.set("sizes", JSON.stringify(sizes));

                    return API.ProjectFileUpload(fd).then(res => {
                        if (!res?.ok) {
                            DEBUG && console.warn(res);
                            throw res;
                        }

                        const imgBySize = Object.entries(res)
                            .map(([key, src]) => {
                                const [w, h] = key.match(/^(\d+)x(\d+)$/) || [];
                                return w && { px: parseFloat(w) * parseFloat(h), src };
                            })
                            .filter(v => v)
                            .sort((a, b) => (a.px === b.px ? 0 : a.px > b.px ? -1 : 1));

                        DEBUG && console.warn("imgBySize", imgBySize);

                        if (imgBySize.length === 0) {
                            parent.retina = parent.normal = `/u/${res.converted}`;
                            parent.src = `/u/${res?.source}`;
                        } else {
                            parent.retina = `/u/${imgBySize[0]?.src}`;
                            parent.normal = `/u/${imgBySize[imgBySize.length - 1].src}`;
                            parent.src = `/u/${imgBySize[imgBySize.length - 1].src}`;
                        }

                        if (parent.file.type) {
                            delete parent.file.type;
                        }

                        if (parent.file.dataUrlBase64) {
                            delete parent.file.dataUrlBase64;
                        }

                        return res;
                    });
                });
        })
    ).then(results => {
        // DEBUG && console.warn(results);
        return true;
    });
}
